import { useState } from "react";
import { EyeOpened } from "../../assets/icons/EyeOpened";
import { EyeClosed } from "../../assets/icons/EyeClosed";
import styles from "./PasswordInput.module.css";

const PasswordInput = ({ name, value, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={styles.passwordInputContainer}>
      <input
        className={styles.passwordInput}
        type={showPassword ? "text" : "password"}
        name={name}
        value={value}
        onChange={onChange}
        required
      />
      {
        <span className={styles.eyeContainer} onClick={togglePasword}>
          {showPassword ? <EyeClosed /> : <EyeOpened />}
        </span>
      }
    </div>
  );
};

export default PasswordInput;
